import { message } from 'antd'
import { downloadBlobFile, getFileNameFromResponse, isDownloadFile } from './utils/BlobSave'
import webConfig from '@/constants/common-env'

// 错误处理方案： 错误类型
enum CodeType {
    SUCCESS = 0,
    NOT_LOGIN = 11002,
    USER_BANNED = 11004,
}

let lastErrorTime = 0 // 上次弹出提示的时间

/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const requestConfig = {
    // baseURL: '/api', //反向代理
    baseURL: webConfig.apiUrl,
    withCredentials: true,
    requestInterceptors: [
        (config) => {
            const url = config?.url;
            return {...config, url};
        },
    ],
    responseInterceptors: [
        (response) => {
            const isDownload = isDownloadFile(response)
            if (isDownload) {
                const contentType = response.headers?.['content-type'] || ''
                const isJson = contentType.includes('application/json') || contentType.includes('text/plain')
                if (isJson) {
                    //转换步骤
                    const file = new FileReader()
                    file.readAsText(response.data, 'utf-8')
                    file.onload = function() {
                        const obj = JSON.parse(file.result)
                        console.log(obj, 'obj')
                        if (obj.code !== CodeType.SUCCESS) {
                            if (obj.message !== '系统错误') {
                                message.error(obj.message)
                            }
                            return Promise.reject()
                        }
                    }
                    return Promise.reject()
                }


                const fileName = getFileNameFromResponse(response)
                const blobData = response.data instanceof Blob ? response.data : new Blob([response.data], { type: contentType })
                downloadBlobFile(blobData, fileName)
                // 直接返回一个提示，不要再往业务代码走
                return Promise.reject({ __downloaded: true })
            }

            // 拦截响应数据，进行个性化处理 response:
            const res = response.data
            const { code, data, message: msg } = res
            // 当前时间
            const currentTime = Date.now()

            if (code === CodeType.USER_BANNED) {
                // 如果用户被封禁，弹出提示并跳转到登录页面
                if (currentTime - lastErrorTime > 2000) {
                    message.error('账户已被封禁，请联系管理员')
                    lastErrorTime = currentTime
                }
                return Promise.reject(msg)
            }

            if (code === CodeType.NOT_LOGIN) {
                // 如果当前时间与上次弹出提示的时间间隔大于 2 秒，则弹出提示
                if (currentTime - lastErrorTime > 2000) {
                    message.error('未登录，请先登录')
                    lastErrorTime = currentTime
                }
                const currentUrl = window.location.href
                window.location.href = webConfig.loginUrl + '?redirectUrl=' + encodeURIComponent(currentUrl)
                return Promise.reject(msg)
            }
            if (code !== CodeType.SUCCESS) {
                // 如果请求失败，给出错误提示
                console.log('请求失败', msg, code)
                if (msg) {
                    message.error(msg)
                }
                return Promise.reject(msg)
            }
            console.log("请求成功", res, data)
            // 始终返回 axios response，让 @umijs/max 在外层再取一次 response.data
            // 否则直接 return data 会导致最终拿到 undefined（因为框架默认会再取一层 .data）
            return { ...response, data }
        },
    ],
}
